import { maxDate, minDate, toCalendarDate, type CalendarDate, type DateValue } from '@internationalized/date';
import type { Context } from 'react';
import type { CalendarStateContext as RACCalendarStateContext } from 'react-aria-components';

/** @internal */
export type CalendarState = typeof RACCalendarStateContext extends Context<infer R> ? NonNullable<R> : never;

/** @internal */
export function getEraFormat(date: CalendarDate | undefined): 'short' | undefined {
  return date?.calendar.identifier === 'gregory' && date.era === 'BC' ? 'short' : undefined;
}

/** @internal */
export function isDateInvalid(date: DateValue, minValue?: DateValue | null, maxValue?: DateValue | null): boolean {
  return (minValue != null && date.compare(minValue) < 0) || (maxValue != null && date.compare(maxValue) > 0);
}

/** @internal */
export function constrainValue(
  date: CalendarDate,
  minValue?: DateValue | null,
  maxValue?: DateValue | null,
): CalendarDate {
  if (minValue) {
    const newDate = maxDate(date, toCalendarDate(minValue));
    if (newDate) {
      date = newDate;
    }
  }

  if (maxValue) {
    const newDate = minDate(date, toCalendarDate(maxValue));
    if (newDate) {
      date = newDate;
    }
  }

  return date;
}
